import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import useNavigationStore from 'src/store/navigation';
import { useSidekickTransition } from './DesktopDrawer/SidekickPane/use-sidekick-transition';

// kept from the retired Assistant panel: outbound links still carry it
const FORCE_OPEN_SIDEKICK_QUERY_PARAM = 'open-assistant';

/** Opens the Sidekick pane for `?open-assistant=true`, and settles the move too. */
export const useOpenSidekickParam = () => {
  const [searchParams] = useSearchParams();
  const setActivePane = useNavigationStore((state) => state.setActivePane);
  const { hasTransitioned, completeTransition } = useSidekickTransition();
  // a ref, not state: re-running the effect after completeTransition() flips
  // hasTransitioned would re-open a pane the user may have since closed
  const hasHandledRef = useRef(false);

  const shouldOpen = searchParams.get(FORCE_OPEN_SIDEKICK_QUERY_PARAM) === 'true';

  useEffect(() => {
    if (!shouldOpen) {
      hasHandledRef.current = false;
      return;
    }
    if (hasHandledRef.current) {
      return;
    }

    hasHandledRef.current = true;
    if (!hasTransitioned) {
      completeTransition();
    }
    setActivePane('sidekick');
  }, [shouldOpen, hasTransitioned, completeTransition, setActivePane]);
};
